import {NewFLowStep} from "~/models/enums";

const navigateAfterLogin = (step: number) => {
    const runtimeConfig = useRuntimeConfig();

    switch (step) {
        case NewFLowStep.Introduction:
            // navigateTo('/new/intro');
            // break;
        case NewFLowStep.Registration:
            navigateTo('/new/complete-info');
            break;
        case NewFLowStep.ChooseMeeting:
        //     navigateTo('/new/road-map');
        //     break;
        case NewFLowStep.ChoosePlan:
            navigateTo('/new/plans');
            break;
        case NewFLowStep.Dashboard:
            window.location.href = `${runtimeConfig.public.Redirect}/role-selection?issigningup=false`
            break;
    }
}

export default navigateAfterLogin;
